import type { WizardComponentAdapterProps } from '@lemonade-hq/chat-wizard-client-base';
import type { Milliseconds, Seconds } from '@lemonade-hq/ts-helpers';
import type { InterpolableTextProps, UniclientAction } from '@lemonade-hq/uniclient-chat';
import { Layout, spacing, Text } from '@lemonade-hq/uniclient-theme';
import { motion } from 'motion/react';
import { WIZARD_DISCLAIMER_ELEMENT_ID } from '../utils/consts';
import { InterpolableText } from './InterpolableText';

export const DISCLAIMER_ANIMATION_DELAY: Milliseconds = 200;

interface WizardDisclaimerProps {
  readonly text: InterpolableTextProps;
  readonly onAction?: (action: UniclientAction) => Promise<unknown>;
  readonly answers?: WizardComponentAdapterProps['answers'];
  readonly extraMargin?: boolean;
  readonly animationDelay?: Seconds;
  readonly layout?: boolean | 'position';
}

export const WizardDisclaimer: React.FC<WizardDisclaimerProps> = ({
  text,
  answers,
  onAction,
  extraMargin,
  animationDelay,
  layout,
}) => (
  <Layout
    animate={{ opacity: 1, transition: { delay: (animationDelay ?? 0) / 1000 } }}
    as={motion.div}
    data-animated
    id={WIZARD_DISCLAIMER_ELEMENT_ID}
    initial={{ opacity: 0 }}
    layout={layout}
    marginBlock={extraMargin ? { sm: spacing.s16, lg: spacing.s40 } : undefined}
  >
    <Text color="$textTertiary" type="bodyTiny" whiteSpace="pre-line">
      <InterpolableText answers={answers} onAction={onAction} text={text} variant="inherit" />
    </Text>
  </Layout>
);
